import pdfmake from 'pdfmake';
import 'pdfmake/build/vfs_fonts.js';
window.pdfmake = pdfmake;